document.addEventListener('DOMContentLoaded', () => {
  // タブ切り替え
  const elements = document.getElementsByClassName('tab')
  const selected_class_name = '-selected'

  Array.from(elements).forEach((element) => {
    element.addEventListener('click', () => {
      Array.from(elements).forEach((ele) => ele.classList.remove(selected_class_name))
      element.classList.add(selected_class_name)
    })
  })

  // モーダル選択反映
  const applyButton = document.getElementById('applyBtn')
  if (applyButton) {
    applyButton.addEventListener('click', () => {
      const kindNames = ['occupation', 'subject', 'pref']
      kindNames.forEach((kind) => modalToForm(kind))
    })
  }
})

function modalToForm(kind) {
  let ids = []
  let names = []
  Array.from(document.getElementsByClassName(kind + 's')).forEach((checkBox) => {
    if (checkBox.checked === true) {
      ids.push(checkBox.value)
      names.push(checkBox.name)
    }
  })
  const idsParent = document.getElementById(`${kind}-ids`)
  // Remove previous ids
  Array.from(idsParent.children).forEach((child) => child.remove())
  // Attach ids
  ids.map((id) => {
    let input = document.createElement('input')
    input.setAttribute('value', id)
    input.setAttribute('multiple', 'multiple')
    input.setAttribute('autocomplete', 'off')
    input.setAttribute('type', 'hidden')
    input.setAttribute('name', `search_query_form[${kind}_ids][]`)

    idsParent.appendChild(input)
  })
  // Attach names
  document.getElementById(`${kind}-names`).innerText = names.length > 0 ? names.join(',') : '選択なし'
}
